import React from 'react'
import style from './main.module.css'
import Home from '../home/Home'
import Services from '../services/Services'
import About from '../about/About'
import Games from '../games/Games'
import Contact from '../contact/Contact'

function Main({ visibleElements, elementsRef }) {
    return (
        <main className={style['main']}>
            <Home visibleElements={visibleElements} elementsRef={elementsRef} />
            <About visibleElements={visibleElements} elementsRef={elementsRef} />
            <Services visibleElements={visibleElements} elementsRef={elementsRef} />
            <Games visibleElements={visibleElements} elementsRef={elementsRef} />
            <Contact visibleElements={visibleElements} elementsRef={elementsRef}/>
        </main>
    )
};
export default Main;
